import Vue from "vue";

export function setName(name) {
  return Vue.ls.set("name", name);
}

export function getName() {
  return Vue.ls.get("name");
}

export function setToken(token) {
  return Vue.ls.set("token", token);
}

export function getToken() {
  return Vue.ls.get("token");
}

export function setUID(uid) {
  return Vue.ls.set("uid", uid);
}

export function getUID() {
  return parseInt(Vue.ls.get("uid"));
}

export function setRole(role) {
  Vue.ls.set("role", JSON.stringify(role));
}

export function getRole() {
  return JSON.parse(Vue.ls.get("role"));
}

export function setType(type) {
  Vue.ls.set("type", type);
}

export function getType() {
  return Vue.ls.get("type");
}

export function setButtons(buttons) {
  Vue.ls.set("buttons", buttons);
}

export function getButtons() {
  return Vue.ls.get("buttons");
}

export function setUser(type) {
  Vue.ls.set("user", type);
}

export function getUser() {
  return Vue.ls.get("user");
}

export function setEncryptedData(type) {
  Vue.ls.set("encryptedData", type);
}

export function getEncryptedData() {
  return Vue.ls.get("encryptedData");
}

export function setIv(type) {
  Vue.ls.set("iv", type);
}

export function getIv() {
  return Vue.ls.get("iv");
}
export function setSessionKey(type) {
  Vue.ls.set("sessionKey", type);
}

export function getSessionKey() {
  return Vue.ls.get("sessionKey");
}

export function clear() {
  return Vue.ls.clear();
}
//
// export function setPermission(permission) {
//     return Vue.ls.set('permission', JSON.stringify(permission));
// }
//
// export function getPermission() {
//     return JSON.parse(Vue.ls.get('permission'));
// }

export function setZlb(type) {
  Vue.ls.set("zlb", type);
}

export function getZlb() {
  return Vue.ls.get("zlb");
}

export function setAuthAlbum(name) {
  return Vue.ls.set("auth_Album", name);
}

export function getAuthAlbum() {
  return Vue.ls.get("auth_Album");
}
